import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { SelectOption } from '@platform/types';
import { COMMUNICATION_TAG_TYPE } from 'emma-common-ts/emma';

export enum EMMA_TEXT_CHECK_MODAL_TYPE {
  AUDIENCE_TAGS = 'audience_tags',
}

@Component({
    selector: 'emma-text-check-modal',
    templateUrl: './emma-text-check-modal.component.html',
    standalone: false
})
export class EMMATextCheckModalComponent implements OnChanges, OnInit {
  @Output() close = new EventEmitter<void>();

  @Input() confirmText = $localize`Aceptar`;
  @Input() confirmColor = 'brand';
  @Input() icon = 'la-spell-check';
  @Input() type?: EMMA_TEXT_CHECK_MODAL_TYPE;
  @Input() items: SelectOption[] = [];
  @Input() text = '';

  EMMA_TEXT_CHECK_MODAL_TYPE = EMMA_TEXT_CHECK_MODAL_TYPE;

  headTitle = '';
  bodyMessage = '';
  emptyCheckMessage = '';

  itemsToCheck: SelectOption[] = [];

  ngOnInit(): void {
    this.getTexti18n();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('type' in changes || 'text' in changes) {
      this.getTexti18n();
      this.processItems();
    }
  }

  private processItems(): void {
    this.itemsToCheck = [];
    if (this.type === EMMA_TEXT_CHECK_MODAL_TYPE.AUDIENCE_TAGS) {
      this.processAudienceTagItems();
    }
  }

  private processAudienceTagItems(): void {
    const value = this.text ?? '';
    const re = /\{{(.+?)\}}/gi;
    const foundTags = new Set(value.match(re) ?? []);
    foundTags.forEach((foundTag) => {
      const itemToCheck = this.items.find(
        (item) => (item.type === COMMUNICATION_TAG_TYPE.AUDIENCE_TAG && foundTag) === item.value
      );
      if (itemToCheck) {
        this.itemsToCheck.push(itemToCheck);
      }
    });
  }

  getTexti18n(): void {
    if (this.type === EMMA_TEXT_CHECK_MODAL_TYPE.AUDIENCE_TAGS) {
      this.headTitle = $localize`Comprobación de etiquetas de audiencia`;
      this.bodyMessage = $localize`Las etiquetas de audiencia definidas pertenecen a las siguiente audiencias:`;
      this.emptyCheckMessage = $localize`No hay etiquetas de audiencia para comprobar.`;
    }
  }

  onClose(): void {
    this.close.emit();
  }
}
